export const NOMEFERMATA_END = 'NOMEFERMATA_END'